import React from "react";
import "./AlertModal.css";

const AlertModal = ({
  message,
  onConfirm,
  onCancel,
  isOpen,
  confirmText,
  cancelText,
}) => {
  if (!isOpen) return null; // Prevent rendering if modal is not open

  return (
    <div className="alert-modal">
      <p>{message}</p>
      <button className="confirm-btn" onClick={onConfirm}>
        {confirmText || "Oui, supprimer"}{" "}
        {/* ✅ Default text if no prop is provided */}
      </button>
      <button className="cancel-btn" onClick={onCancel}>
        {cancelText || "Annuler"} {/* ✅ Default text if no prop is provided */}
      </button>
    </div>
  );
};

export default AlertModal;
